import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { InternalAuthService } from '../internal-auth.service';


@Component({
	selector: 'common-internal-signed-out',
	imports: [CommonModule],
	templateUrl: './internal-signed-out.widget.html'
})
export class CommonInternalSignedOutWidget {

	private readonly auth = inject(InternalAuthService);

	public signIn() {
		this.auth.internalSignIn();
	}
}
